export default __webpack_public_path__ + "static/media/le_mont.a5cb60d9.jpg";